<template>
  <div
    class="app-container mt-5 mb-5"
    id="connexions"
  >
    <!-- Header -->
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex">
        <div class="page-title">
          <span class="breadcrumb-link">
            <img
              src="/images/logo_USKA_empty_blue.png"
              height="20"
              width="20"
            />
            Uska
          </span>
        </div>
        <div class="d-flex ml-5 mt-auto mb-auto">
          <div
            class="mt-auto mb-auto cliquable-state"
            :class="{ active: isArchived }"
            @click="setArchived(true)"
          >
            Archivées
          </div>
          <div
            class="mt-auto mb-auto cliquable-state"
            :class="{ active: !isArchived }"
            @click="setArchived(false)"
          >
            <div>En cours</div>
            <div class="floating-notification" v-if="uskaNotifications">
              <span>{{ uskaNotifications }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <v-card class="mt-5 overflow-hidden">
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          Demandes de mise en relation
          <span class="px-1 blue-grey lighten-4 text-white ml-1 rounded">
            {{ connexionsList.length }}
          </span>
        </v-tab>
        <v-tab href="#tab-2">
          Demandes de mise à jour
          <span class="px-1 blue-grey lighten-4 text-white ml-1 rounded">
            {{ majsList.length }}
          </span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <ConnexionsList
            :list="connexionsList"
            :is-loading="isLoading"
            @reload="getConnexionsList"
          />
        </v-tab-item>
        <v-tab-item value="tab-2">
          <MajList
            :list="majsList"
            :is-loading="isLoading"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import ConnexionsList from "./managementList/ConnexionsList.vue"
import MajList from "./managementList/MajList.vue"

export default {
  name: "Management",

  components: { ConnexionsList, MajList },

  data() {
    return {
      tab: "tab-2",
      connexionsList: [],
      majsList: [],
      isLoading: false,
    }
  },

  computed: {
    ...mapState("connexionFilter", ["displayMode", "archived"]),
    ...mapState("account", ["user", "uskaNotifications"]),
    isArchived: {
      get() {
        return this.archived
      },
      set(value) {
        this.setArchived(value)
      },
    },
  },

  watch: {
    isArchived() {
      // this.options.page = 1
      this.getConnexionsList()
    },
  },

  created() {
    this.getConnexionsList()
  },

  methods: {
    ...mapMutations("connexionFilter", ["setArchived"]),
    getConnexionsList() {
      this.isLoading = true

      this.$http
        .post("auth/pro-connexions", {
          archived: this.isArchived,
        })
        .then((res) => {
          this.connexionsList = res.body.data.proConnexions
          this.majsList = res.body.data.majDemands
          this.isLoading = false
        })
    },
  },
}
</script>
